export default "__VITE_ASSET__CDyw5GIj__"